__webpack_require__.p = "https://documents.gu.ac.ug/";